import React from "react"

import { Upload, message } from "antd"
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons"
import firebase from "firebase"
import randomstring from "randomstring"

function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener("load", () => callback(reader.result))
  reader.readAsDataURL(img)
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png"
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!")
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!")
  }
  return isJpgOrPng && isLt2M
}

export default function Icon({
  image = {},
  setImage = () => {},
  auth,
  setImagePath = () => {},
}) {
  const { imageUrl, loading } = image

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setImage({ ...image, loading: true })
      return
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (imageUrl) =>
        setImage({ ...image, imageUrl, loading: false })
      )
    }
  }

  const customUpload = async ({ onError, onSuccess, file }) => {
    const storage = firebase.storage()
    const metadata = {
      contentType: "image/jpeg",
    }
    const storageRef = await storage.ref()
    const imageName = randomstring.generate({
      length: 8,
      readable: true,
      capitalization: "lowercase",
    }) //a unique name for the image
    const imagePath = `${auth.uid}/${imageName}.png`
    const imgFile = storageRef.child(imagePath)
    try {
      const image = await imgFile.put(file, metadata)
      setImagePath(imagePath)
      onSuccess(null, image)
    } catch (e) {
      console.log(`e`, e)
      onError(e)
    }
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )
  return (
    <Upload
      name="avatar"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      customRequest={customUpload}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
      ) : (
        uploadButton
      )}
    </Upload>
  )
}
